import { useState } from "react";
import { Outlet } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
//
import Header from "./header";
import Nav from "./nav";

import SimpleFooter from "../../components/SimpleFooter";
import StickyFeedbackButton from "../../components/StickyFeedbackButton";

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled("div")({
  display: "flex",
  minHeight: "100%",
  overflow: "hidden",
});

const Main = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",

  display: "flex",
  flexDirection: "column",
  paddingBottom: theme.spacing(2),

  paddingTop: APP_BAR_MOBILE + 24,
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);

  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpen(true)} />
      <Nav openNav={open} onCloseNav={() => setOpen(false)} />

      <Main>
        <div style={{ flexGrow: 1 }}>
          <Outlet />
        </div>

        <SimpleFooter />
      </Main>

      {/* Sticky Feedback Button - Available on all pages */}
      <StickyFeedbackButton />

      {/* <footer className="footer bg-white">
                <p
                    className="trademark text-secondary"
                    style={{ backgroundColor: "transparent" }}
                >
                    <span className="logo">Contactie &trade;</span>
                </p>
                <a
                    className="logo-link"
                    href="/"
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    <span className="logo">Contactie</span>
                </a>
            </footer> */}
    </StyledRoot>
  );
}
